import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { sr } from "./local/sr/home";
import { sr as srCommon } from "./local/sr/common";

const resources = {
  sr: {
    translation: {
      ...sr.translation,
      ...srCommon.translation,
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "sr",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;